import { render, staticRenderFns } from "./custom-main.vue?vue&type=template&id=0102dc18&scoped=true&"
import script from "./custom-main.vue?vue&type=script&lang=ts&"
export * from "./custom-main.vue?vue&type=script&lang=ts&"
import style0 from "./custom-main.vue?vue&type=style&index=0&id=0102dc18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0102dc18",
  null
  
)

export default component.exports